<template>
  <div>
    <input
      class="input title"
      type="text"
      placeholder="Caption"
      :value="getCaption()"
      @input="update('caption', $event.target.value)"
    >
    <h2 class="subTitle">
      <b>Song:</b>
      {{ playlistItem.song_version ? playlistItem.song_version.title : "?" }}
    </h2>
    <search-song
      :show-tags="true"
      :initial-tags="songTags"
      @selectSong="update('song_version', $event)"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import SearchSong from "../components/SearchSong";

export default {
  components: {
    SearchSong
  },
  computed: {
    ...mapGetters({
      playlistItem: "selectedPlaylistItem",
      songTags: "selectedPlaylistItemTags"
    }),
    ...mapState(["tags"])
  },
  mounted() {
    this.fetchPlayListItem({
      playlistId: this.$route.params.playlistId,
      itemId: this.$route.params.playlistItemId
    });
  },
  methods: {
    getCaption() {
      if (this.playlistItem.caption == null) {
        return this.playlistItem.template_item
          ? this.playlistItem.template_item.caption
          : "";
      } else return this.playlistItem.caption;
    },
    ...mapActions(["updatePlaylistItem", "fetchPlayListItem"]),
    update(path, value) {
      this.updatePlaylistItem({
        path,
        value
      });
    }
  }
};
</script>

<style lang="scss">
.more {
  font-weight: bold;
}
.more:hover {
  color: #00d1b2;
}
</style>



// WEBPACK FOOTER //
// PlaylistItemEdit.vue?57206ae8